import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducers from './reducers'

const history = createBrowserHistory()
const routeMiddleware = routerMiddleware(history)
const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production') {
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

function configureStore(initialState = {}) {
  return createStore(
    reducers(history),
    initialState,
    bindMiddleware([routeMiddleware, thunk]),
  )
}

const store = configureStore()

export { history, store }
